<template>
	<!--搜索聊天内容弹框-->
	<el-dialog title="搜索聊天内容" width="55%" :visible.sync="dialogSearchs" :before-close="close">
		<div class="model-search">
			<el-input
				placeholder="请输入内容"
				v-model="input10"
				clearable
				class="search_box"
				@keyup.enter.native="searchKey"
			>
				<input type="text" autocomplete="off" placeholder="请输入内容" />
				<el-button slot="append" icon="el-icon-search" @click="searchKey"></el-button>
			</el-input>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="全部" name="all">
				<historicalRecord
					:list="list"
					:consultNickName="consultNickName"
					:consultDefaultHeadimg="consultDefaultHeadimg"
					:kfDefaultHeadimg="kfDefaultHeadimg"
					:noMore="noMore"
					:searchLoading="searchLoading"
					@onReachTheBottom="onReachTheBottom"
				></historicalRecord>
				<!-- <div class="all" id="Monitorall">
					<div class="flex-content" v-for="item in list">
						<div class="g-infor">
							<div class="g-headimg">
								<img :src="consultDefaultHeadimg" v-if="item.dialogues[0].sender==1" />
								<img :src="kfDefaultHeadimg" v-if="item.dialogues[0].sender==2" />
							</div>
							<div class="talk_record">
								<div class="ename" v-if="item.dialogues[0].sender===1">{{consultNickName}}</div>
								<div class="ename" v-if="item.dialogues[0].sender===2">{{item.sendNickName}}</div>
								<div class="talk_content">
									<span v-for="items in item.dialogues">
										<img v-if="items.messageType===2" :src="items.content" v-image-preview />
										<video v-else-if="items.messageType===3" :src="items.content"></video>
										<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
										<span v-else>{{items.content}}</span>
									</span>
								</div>
							</div>
						</div>
						<div class="creatime">{{getTime(item.sendTime)}}</div>
					</div>
				</div>-->
			</el-tab-pane>
			<el-tab-pane label="图片" name="2">
				<historicalRecord
					:list="list"
					:consultNickName="consultNickName"
					:consultDefaultHeadimg="consultDefaultHeadimg"
					:kfDefaultHeadimg="kfDefaultHeadimg"
					:noMore="noMore"
					:searchLoading="searchLoading"
					@onReachTheBottom="onReachTheBottom"
				></historicalRecord>
				<!-- <div class="all" id="Monitor2">
					<div class="flex-content" v-for="item in list">
						<div class="g-infor">
							<div class="g-headimg">
								<img :src="consultDefaultHeadimg" v-if="item.dialogues[0].sender==1" />
								<img :src="kfDefaultHeadimg" v-if="item.dialogues[0].sender==2" />
							</div>
							<div class="talk_record">
								<div class="ename" v-if="item.dialogues[0].sender===1">{{consultNickName}}</div>
								<div class="ename" v-if="item.dialogues[0].sender===2">{{item.sendNickName}}</div>
								<div class="talk_content">
									<span v-for="items in item.dialogues">
										<img v-if="items.messageType===2" :src="items.content" v-image-preview />
										<video v-else-if="items.messageType===3" :src="items.content"></video>
										<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
										<span v-else>{{items.content}}</span>
									</span>
								</div>
							</div>
						</div>
						<div class="creatime">{{getTime(item.sendTime)}}</div>
					</div>
				</div>-->
			</el-tab-pane>
			<el-tab-pane label="视频" name="3">
				<historicalRecord
					:list="list"
					:consultNickName="consultNickName"
					:consultDefaultHeadimg="consultDefaultHeadimg"
					:kfDefaultHeadimg="kfDefaultHeadimg"
					:noMore="noMore"
					:searchLoading="searchLoading"
					@onReachTheBottom="onReachTheBottom"
				></historicalRecord>
				<!-- <div class="all" id="Monitor3">
					<div class="flex-content" v-for="item in list">
						<div class="g-infor">
							<div class="g-headimg">
								<img :src="consultDefaultHeadimg" v-if="item.dialogues[0].sender==1" />
								<img :src="kfDefaultHeadimg" v-if="item.dialogues[0].sender==2" />
							</div>
							<div class="talk_record">
								<div class="ename" v-if="item.dialogues[0].sender===1">{{consultNickName}}</div>
								<div class="ename" v-if="item.dialogues[0].sender===2">{{item.sendNickName}}</div>
								<div class="talk_content">
									<span v-for="items in item.dialogues">
										<img v-if="items.messageType===2" :src="items.content" v-image-preview />
										<video
											v-else-if="items.messageType===3"
											:src="items.content"
											controls="controls"
											style="width:150px;height:150px;"
										></video>
										<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
										<span v-else>{{items.content}}</span>
									</span>
								</div>
							</div>
						</div>
						<div class="creatime">{{getTime(item.sendTime)}}</div>
					</div>
				</div>-->
			</el-tab-pane>
			<el-tab-pane label="链接" name="6">
				<historicalRecord
					:list="list"
					:consultNickName="consultNickName"
					:consultDefaultHeadimg="consultDefaultHeadimg"
					:kfDefaultHeadimg="kfDefaultHeadimg"
					:noMore="noMore"
					:searchLoading="searchLoading"
					@onReachTheBottom="onReachTheBottom"
				></historicalRecord>
				<!-- <div class="all" id="Monitor6">
					<div class="flex-content" v-for="item in list">
						<div class="g-infor">
							<div class="g-headimg">
								<img :src="consultDefaultHeadimg" v-if="item.dialogues[0].sender==1" />
								<img :src="kfDefaultHeadimg" v-if="item.dialogues[0].sender==2" />
							</div>
							<div class="talk_record">
								<div class="ename" v-if="item.dialogues[0].sender===1">{{consultNickName}}</div>
								<div class="ename" v-if="item.dialogues[0].sender===2">{{item.sendNickName}}</div>
								<div class="talk_content">
									<span v-for="items in item.dialogues">
										<img v-if="items.messageType===2" :src="items.content" v-image-preview />
										<video v-else-if="items.messageType===3" :src="items.content" controls="controls"></video>
										<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
										<span v-else>{{items.content}}</span>
									</span>
								</div>
							</div>
						</div>
						<div class="creatime">{{getTime(item.sendTime)}}</div>
					</div>
				</div>-->
			</el-tab-pane>
		</el-tabs>
	</el-dialog>
</template>
<script>
import { FormatTimes } from '@/utils/FormatTime'
import historicalRecord from './historicalRecord'
export default {
	name: 'searchSession',
	data() {
		return {
			dialogSearchs: false,
			input10: '',
			tagDatas: [],
			activeName: 'all',
			list: [],
			pagination: {},
			searchLoading: false,
			noMore: false
		}
	},
	props: {
		dialogSearch: {
			type: Boolean,
			default: false
		},
		tagData: {
			type: Array,
			default: () => []
		},
		searchDialogues: {
			type: Object,
			default: () => {}
		},
		kefuName: {
			type: String,
			default: '客服'
		},
		consultName: {
			type: String,
			default: '匿名'
		},
		searchKeyWord: {
			type: String,
			default: ''
		},
		currentObj: {
			type: Object,
			default: () => {}
		},
		kfDefaultHeadimg: {
			type: String,
			default: ''
		},
		consultDefaultHeadimg: {
			type: String,
			default: ''
		},
		consultNickName: {
			type: String,
			default: ''
		}
	},
	watch: {
		tagData: function(val) {},
		// searchDialogues: function(val) {
		// 	this.list = val.list
		// 	this.pagination = val.pagination
		// },
		searchDialogues: {
			handler(cval, oval) {
				this.list = cval.list
				this.pagination = cval.pagination
			},
			deep: true
		},
		searchKeyWord: function(val) {
			this.input10 = val
		},
		dialogSearch: {
			handler(cval, oval) {
				this.dialogSearchs = cval
			},
			deep: true
		}
	},
	mounted: function() {},
	components: {
		historicalRecord
	},
	methods: {
		handleClick: function(val) {
			this.reset() //重置
			this.noMore = false
			// if (val.name != 'all') {
			// 	this.search(val.name)
			// } else {
			// 	this.request()
			// }
			this.activeName = val.name
			this.loadingSearchKey()
		},
		getTime(time) {
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		},
		search(key) {
			// vm.searchLoading = true
			let vm = this
			var obj = new Object()
			obj.messageType =
				key == undefined ? parseInt(vm.activeName) : parseInt(key)
			obj.keyWord = vm.input10
			vm.$emit('searchDialogue', obj, e => this.searchLoadings(e))
			// vm.list = []
		},
		searchKey() {
			if (this.activeName == 'all') {
				this.request()
			} else {
				this.search()
			}

			this.reset()
		},
		loadingSearchKey() {
			if (this.activeName == 'all') {
				this.request()
			} else {
				this.search()
			}
		},
		request() {
			this.pagination.pageIndex = this.pagination.pageIndex + 1
			let vm = this
			let obj = new Object()
			obj.pagination = vm.pagination
			obj.conversationLogId = vm.currentObj.conversationLogId
			obj.ConsultId = vm.currentObj.consultId
			obj.content = vm.input10
			// vm.searchLoading = true
			vm.$emit('SearchChatBox', obj, e => this.searchLoadings(e))
		},
		close() {
			this.$emit('close', false)
		},
		searchLoadings(data) {
			if (data.list == undefined) {
				this.list = this.list.concat(data)
			}
			if (data.list != undefined) {
				this.list = this.list.concat(data.list)
				this.pagination = data.pagination
			}
			this.searchLoading = false
		},
		handleScroll(id) {
			var testDiv = document.getElementById(id)
			var scrollTop = testDiv.scrollTop
		},
		onReachTheBottom() {
			let vm = this
			let pageCount = vm.pagination.total / vm.pagination.pageSize
			if (vm.pagination.pageIndex <= pageCount) {
				vm.loadingSearchKey()
				vm.searchLoading = true
				vm.noMore = false
			} else {
				vm.noMore = true
			}
		},
		reset() {
			this.pagination = { pageIndex: 0, pageSize: 30, total: 0 }
			this.list = []
		}
	}
}
</script>
<style scoped>
/*搜索聊天内容*/
video {
	width: 150px;
	height: 150px;
}

.flex-content {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
}
.g-infor {
	width: 80%;
}
.g-headimg {
	float: left;
}
.g-headimg img {
	width: 50px;
	height: 50px;
	border-radius: 50%;
}
.talk_record {
	float: left;
	margin-left: 30px;
	width: 80%;
}
.flex-content .ename {
	color: #999;
	line-height: 25px;
}
.flex-content .talk_content {
	line-height: 25px;
}
.flex-content .creatime {
	color: #666;
	margin-right: 20px;
}
.talk_content img {
	width: 200px;
}

.custom_list {
	margin-top: 30px;
	max-height: 300px;
	overflow-y: auto;
}
.section {
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
}
.note {
	margin-top: 50px;
}
.choose {
	float: right;
	margin-top: 10px;
}
.el-icon-success {
	cursor: pointer;
}
.el-icon-success:before {
	font-size: 35px;
}
.avatar {
	width: 60px;
	height: 60px;
	float: left;
	position: relative;
}
.avatar img {
	width: 60px;
	height: 60px;
	border-radius: 50%;
}
.avatar span {
	position: absolute;
	width: 20px;
	height: 10px;
	border-radius: 10px;
	background-color: #5abc5c;
	text-align: center;
	color: #fff;
	bottom: 0;
	left: 50%;
	margin-left: -10px;
}
.infor {
	float: left;
	margin-left: 30px;
}
.infor .ename {
	line-height: 25px;
	font-size: 10px;
	margin-top: 10px;
	height: 25px;
}
.infor .number {
	line-height: 25px;
	font-size: 10px;
}
.pinpai {
	float: left;
	margin-left: 60px;
}
.current {
	margin-left: 60px;
}

.model-search {
	width: 100%;
}
.model-search .el-input {
	width: 80%;
}
.model-search .el-button {
	background-color: #fafafa;
}
.all::-webkit-scrollbar {
	width: 8px;
}

.el-tabs__content {
	max-height: 500px;
}
.el-dialog__body {
	height: 500px;
	padding: 30px 20px;
	color: #606266;
	font-size: 14px;
	word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/searchSession.vue